import styled from '@emotion/styled';
import { tableHover } from 'app/colors';
import { layers } from 'app/spacing';
import { Gradient as BaseGradient } from '__components/Kizen/ScrollFadeContainer';
import { FlowBar as FlowBarBase } from './ControlBar';
import { Button as ButtonKDS } from '@kizen/kds/Button';
import css from '@emotion/css';
import { FLOW_BAR_HEIGHT } from 'pages/AutomationEngine/ControlBar';

const SIDEBAR_WIDTH = 300;

export const Wrapper = styled.div<{ navHeight: number }>`
  height: calc(100vh - ${({ navHeight }) => navHeight}px);
  display: flex;
  flex-direction: column;
  position: relative; // Create a stacking context to ensure ControlBar is on top
  background: ${tableHover};
  overflow: hidden; // Dragging off-screen should not cause scroll
  .ControlBar {
    z-index: ${layers.content(0, 2)};
  }
  .FlowContainer {
    flex: 1;
    z-index: ${layers.content(0)};
    position: relative; // For placing scrollbars
  }

  /* That are the styles from  'reactflow/dist/base.css'
  we would need to update this if we ever update reactflow */

  .react-flow__container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .react-flow__pane {
    z-index: 1;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .react-flow__pane.selection {
    cursor: pointer;
  }
  .react-flow__pane.dragging {
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  .react-flow__viewport {
    transform-origin: 0 0;
    z-index: 2;
    pointer-events: none;
  }
  .react-flow__renderer {
    z-index: 4;
  }
  .react-flow__selection {
    z-index: 6;
  }
  .react-flow__nodesselection-rect:focus,
  .react-flow__nodesselection-rect:focus-visible {
    outline: none;
  }
  .react-flow .react-flow__edges {
    pointer-events: none;
    overflow: visible;
  }
  .react-flow__edge-path,
  .react-flow__connection-path {
    stroke: #b1b1b7;
    stroke-width: 1;
    fill: none;
  }
  .react-flow__edge {
    pointer-events: visibleStroke;
    cursor: pointer;
  }
  .react-flow__edge.animated path {
    stroke-dasharray: 5;
    -webkit-animation: dashdraw 0.5s linear infinite;
    animation: dashdraw 0.5s linear infinite;
  }
  .react-flow__edge.animated path.react-flow__edge-interaction {
    stroke-dasharray: none;
    -webkit-animation: none;
    animation: none;
  }
  .react-flow__edge.inactive {
    pointer-events: none;
  }
  .react-flow__edge.selected,
  .react-flow__edge:focus,
  .react-flow__edge:focus-visible {
    outline: none;
  }
  .react-flow__edge.selected .react-flow__edge-path,
  .react-flow__edge:focus .react-flow__edge-path,
  .react-flow__edge:focus-visible .react-flow__edge-path {
    stroke: #555;
  }
  .react-flow__edge-textwrapper {
    pointer-events: all;
  }
  .react-flow__edge-textbg {
    fill: white;
  }
  .react-flow__edge .react-flow__edge-text {
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  .react-flow__connection {
    pointer-events: none;
  }
  .react-flow__connection .animated {
    stroke-dasharray: 5;
    -webkit-animation: dashdraw 0.5s linear infinite;
    animation: dashdraw 0.5s linear infinite;
  }
  .react-flow__connectionline {
    z-index: 1001;
  }
  .react-flow__nodes {
    pointer-events: none;
    transform-origin: 0 0;
  }
  .react-flow__node {
    position: absolute;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    pointer-events: all;
    transform-origin: 0 0;
    box-sizing: border-box;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .react-flow__node.dragging {
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  .react-flow__nodesselection {
    z-index: 3;
    transform-origin: left top;
    pointer-events: none;
  }
  .react-flow__nodesselection-rect {
    position: absolute;
    pointer-events: all;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .react-flow__handle {
    position: absolute;
    pointer-events: none;
    min-width: 5px;
    min-height: 5px;
    background-color: 'transparent';
  }
  .react-flow__handle.connectable {
    pointer-events: all;
    cursor: crosshair;
  }
  .react-flow__handle-bottom {
    top: auto;
    left: 50%;
    bottom: -4px;
    transform: translate(-50%, 0);
  }
  .react-flow__handle-top {
    left: 50%;
    top: -4px;
    transform: translate(-50%, 0);
  }
  .react-flow__handle-left {
    top: 50%;
    left: -4px;
    transform: translate(0, -50%);
  }
  .react-flow__handle-right {
    right: -4px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .react-flow__edgeupdater {
    cursor: move;
    pointer-events: all;
  }
  .react-flow__panel {
    position: absolute;
    z-index: 5;
    margin: 15px;
  }
  .react-flow__panel.top {
    top: 0;
  }
  .react-flow__panel.bottom {
    bottom: 0;
  }
  .react-flow__panel.left {
    left: 0;
  }
  .react-flow__panel.right {
    right: 0;
  }
  .react-flow__panel.center {
    left: 50%;
    transform: translateX(-50%);
  }
  .react-flow__attribution {
    font-size: 10px;
    background: rgba(255, 255, 255, 0.5);
    padding: 2px 3px;
    margin: 0;
  }
  .react-flow__attribution a {
    text-decoration: none;
    color: #999;
  }
  @-webkit-keyframes dashdraw {
    from {
      stroke-dashoffset: 10;
    }
  }
  @keyframes dashdraw {
    from {
      stroke-dashoffset: 10;
    }
  }
  .react-flow__edgelabel-renderer {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .react-flow__node-default,
  .react-flow__node-input,
  .react-flow__node-output,
  .react-flow__node-group {
    border-width: 1px;
    border-style: solid;
    border-color: #bbb;
  }
  .react-flow__node-default.selected,
  .react-flow__node-default:focus,
  .react-flow__node-default:focus-visible,
  .react-flow__node-input.selected,
  .react-flow__node-input:focus,
  .react-flow__node-input:focus-visible,
  .react-flow__node-output.selected,
  .react-flow__node-output:focus,
  .react-flow__node-output:focus-visible,
  .react-flow__node-group.selected,
  .react-flow__node-group:focus,
  .react-flow__node-group:focus-visible {
    outline: none;
    border: 1px solid #555;
  }
  .react-flow__nodesselection-rect,
  .react-flow__selection {
    background: rgba(150, 150, 180, 0.1);
    border: 1px dotted rgba(155, 155, 155, 0.8);
  }
  .react-flow__controls {
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.08);
  }
  .react-flow__controls-button {
    border: none;
    background: #fefefe;
    border-bottom: 1px solid #eee;
    box-sizing: content-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    padding: 5px;
  }
  .react-flow__controls-button:hover {
    background: #f4f4f4;
  }
  .react-flow__controls-button svg {
    width: 100%;
    max-width: 12px;
    max-height: 12px;
  }
  .react-flow__minimap {
    background-color: #fff;
  }
`;

export const FlowBar = styled(FlowBarBase)`
  z-index: ${layers.content(0, 1)};
`;

export const Gradient = styled(BaseGradient)`
  z-index: ${layers.content(0, 5)}; // On top of react-flow
`;

export const PersistBlocker = styled.div`
  content: '';
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${layers.blocker};
`;

const FLOWBAR_HEIGHT = 101; // height of flowbar

export const HistoryWrapperPage = styled.div<{ navHeight: number }>`
  width: 100vw;
  height: calc(
    100vh - ${({ navHeight }) => (navHeight || 51) + FLOWBAR_HEIGHT}px
  );
  display: flex;
`;

export const HistorySideBar = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 ${SIDEBAR_WIDTH}px;
  min-height: 1px;
  position: relative;
  padding-bottom: 30px;
  background: #fff;
`;

export const HistoryButtons = styled.div`
  width: 100%;
  height: ${FLOW_BAR_HEIGHT}px;
  display: flex;
  flex-direction: row;
  flex: 0 0 ${SIDEBAR_WIDTH}px;
  min-height: 1px;
  position: absolute;

  background: #fff;
  top: -${FLOW_BAR_HEIGHT}px;
  left: 0px;
  justify-content: space-evenly;
  align-items: center;
  z-index: 2;
`;

export const ButtonWrapper = styled.div`
  width: ${SIDEBAR_WIDTH - 15}px;
  height: 100%;
  margin: 0px 5px 10px 10px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 1px;
`;

export const ButtonCard = styled.div<{
  color: string;
  disabled: boolean;
  hoverColor: string;
}>`
  width: ${SIDEBAR_WIDTH - 25}px;

  background-color: ${({ color }) => color};
  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
  ${({ disabled, hoverColor }) =>
    disabled
      ? css`
          background-color: ${hoverColor};
          &:hover {
            background-color: ${hoverColor};
          }
        `
      : css`
          cursor: pointer;
        `}
  border-radius: 5px;
  padding: 5px;

  display: flex;

  > .circle {
    flex: 50px 0 0;
  }

  > .text {
    display: flex;
    flex: 1;
    width: calc(100% - 50px);
    > .status {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    flex-direction: column;
    row-gap: 3px;
  }
`;
export const NumberWrapper = styled.div<{ color: string }>`
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ color }) => `${color}`};
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

export const HistoryButton = styled(ButtonKDS)`
  min-width: 100px;
`;

export const TopGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={18} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  top: -2px;
`;

export const BottomGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={36} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  bottom: -2px;
`;
